import React, { useState, useEffect, useCallback } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Filter from "../../elements/filter";
import ReportSummary from "../../elements/reportSummary";
import MenuReportView from "./views/reportView";
import "../style.scss";
import { useAppContext } from "../../../../AppContext";

const routes = [
  {
    name: "Menu Engineering",
    path: "menu-engineering",
    reportType: "menu-engineering",
  },
  {
    name: "Menu by Item Rank",
    path: "item-rank",
    reportType: "by-item-ranked",
  },
];

function MenuReports() {
  const location = useLocation();
  const { user, chimeraserv, components, setFilterValue } = useAppContext();
  const [filter, setFilter] = useState(null);

  // Reset the generated report whenever the user switches report page
  useEffect(() => {
    setFilter(null);
    setFilterValue(null);
    // eslint-disable-next-line
  }, [location.pathname]);

  const handleSetFilter = useCallback(
    (filters) => {
      setFilter(null);
      setFilterValue(null);
      setTimeout(() => {
        setFilter(filters);
        setFilterValue(filters);
      }, 300);
    },
    [setFilterValue]
  );

  const current =
    routes.find((route) => route.path === location.pathname.split("/")[3]) ||
    routes[0];

  const renderReport = (route) =>
    filter ? (
      <section>
        <ReportSummary filter={filter} />
        <MenuReportView
          user={user}
          chimeraserv={chimeraserv}
          filter={filter}
          title={route.name}
          reportType={route.reportType}
          key={`${route.path}-${filter.timestamp}`}
        />
      </section>
    ) : (
      <div
        style={{
          textAlign: "center",
          padding: "40px",
          backgroundColor: "#f8f9fa",
          border: "1px solid #dee2e6",
          borderRadius: "8px",
          margin: "20px 0",
        }}
      >
        <h4>No Report Generated</h4>
        <p>
          Select filters and click "Generate Report" to view{" "}
          {route.name.toLowerCase()}.
        </p>
      </div>
    );

  return (
    <section>
      <Helmet>
        <title>{`${current.name} | Reports | Chimera Solutions | Insights`}</title>
      </Helmet>
      <Filter
        location={location.pathname}
        setFilter={handleSetFilter}
        key={location.pathname}
      />

      <div className={["report"]}>
        <div className={["viewTitle"]}>{current.name}</div>

        <Routes>
          <Route path="/" element={renderReport(routes[0])} />
          {routes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={renderReport(route)}
            />
          ))}
          <Route
            path="*"
            element={
              components.setting[0].component
                ? React.createElement(components.setting[0].component)
                : null
            }
          />
        </Routes>
      </div>
    </section>
  );
}

export default MenuReports;
